"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const provider_test_id_1 = require("@framework/provider-test-id");
const SliderInput = props => {
    const { name, label, ...rest } = props;
    const { testId } = (0, provider_test_id_1.useTestId)();
    const testIdProps = testId ? { "data-testid": `${testId}-${name}` } : {};
    const suffix = name.split(".").pop();
    const form = (0, react_hook_form_1.useFormContext)();
    const value = (0, react_hook_form_1.useWatch)({ name });
    const error = (0, react_hook_form_1.get)(form.formState.errors, name);
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const localizedLabel = label === void 0 ? formatMessage({ id: `form.labels.${suffix}` }) : label;
    const localizedHelperText = error ? formatMessage({ id: error.message }, { label: localizedLabel }) : "";
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.Controller, { name: name, control: form.control, render: ({ field }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { labelPlacement: "start", sx: { width: "100%", mx: 0 }, control: (0, jsx_runtime_1.jsx)(material_1.Slider, { ...field, name: name, value: value, sx: { ml: 2 }, onChange: (_event, value) => {
                            form.setValue(name, value, { shouldTouch: true });
                        }, ...testIdProps, ...rest }), label: localizedLabel }), localizedHelperText && ((0, jsx_runtime_1.jsx)(material_1.FormHelperText, { id: `${name}-helper-text`, error: true, children: localizedHelperText }))] })) }));
};
exports.SliderInput = SliderInput;
//# sourceMappingURL=index.js.map